
import React, { useEffect, useState } from 'react';
import {
    AppBar,
    Tabs,
    Tab,
    Box,
    Typography,
    CssBaseline,
    Snackbar,
    Alert,
    Container,
} from '@mui/material';
import BrandForm from '../views/BrandForm';
import BrandTable from '../views/BrandTable';
import ModelForm from '../views/ModelForm';
import ModelTable from '../views/ModelTable';
import ModelFilter from '../views/ModelFilter';
import TabPanel from '../views/TabPanel'; // Import the TabPanel component
import BodyForm from './BodyForm';
import BodyTable from './BodyTable';
import EngineForm from './EngineForm';
import EngineTable from './EngineTable';
import { useCarContext } from '../components/Context/CarContext';
import { useSnackbar } from './SnackBar';



const CarMaster = ({ carbrands, carmodels, addBrand, bodytype, engineclass, deleteBrand }) => {

    const [tabIndex, setTabIndex] = useState(0); // State to manage active tab
    const { editType, currentEditData, UpdateModel,editOpen, setEditOpen,UpdateEngineClass, engine,UpdateBrand, UpdateBody } = useCarContext();

    const { showSnackbar } = useSnackbar();
    


    //// State for Edit Dialog
    //const [editOpen, setEditOpen] = useState(false);
    //const [editType, setEditType] = useState('brand'); // 'brand' or 'model'
    //const [currentEditData, setCurrentEditData] = useState(null);
    //const [updated, setUpdated] = useState(null);


    // State for Model Filter
    const [selectedBrandFilter, setSelectedBrandFilter] = useState('');
    const [selectedBodyFilter, setSelectedBodyFilter] = useState('');
    const [selectedEngineFilter, setSelectedEngineFilter] = useState('');
    // Handle Tab Change
    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue);
        // Reset filter when switching tabs
        if (newValue === 1) {
            setSelectedBrandFilter('');
        }
    };

    //const editEngine = (engineclass) => {
    //    setEditType('engine');
    //    setCurrentEditData(engineclass);
    //    setEditOpen(true);
    //};
    const deleteEngine = (engineclassId) => {

        // If the deleted brand was selected in the filter, reset the filter
        if (selectedEngineFilter === engineclassId) {
            setSelectedEngineFilter('');
        }
    };

    const deleteBody = (bodytypeId) => {

        // If the deleted brand was selected in the filter, reset the filter
        if (selectedBodyFilter === bodytypeId) {
            setSelectedBodyFilter('');
        }
    };

    //const editBrand = (brand) => {
    //    setEditType('brand');
    //    setCurrentEditData(brand);
    //    setEditOpen(true);
    //};
    
    // CRUD Operations for Models
    const addModel = (model) => {

    };

    const deleteModel = (modelId) => {

    };

    //const editModel = (model) => {
    //    setEditType('model');
    //    setCurrentEditData(model);
    //    setEditOpen(true);
    //};

    // Handle Save from Edit Dialog
    const handleSaveEdit = (updatedData) => {
       
       if (editType === 'model') {
        
            UpdateModel(updatedData);

        }
        else if (editType === 'body') {
          
            UpdateBody(updatedData);
        }
        else if (editType === 'engine') {
           
            UpdateEngineClass(updatedData);
        }
        
        //setEditOpen(false);
        //setCurrentEditData(null);
    };



    return (

        <main id="main" className="main">
            <div className="pagetitle">
                <h1>Car Master</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/admin">Home</a></li>
                        <li className="breadcrumb-item"><a href="#">Carmaster</a></li>
                       
                    </ol>
                </nav>
            </div>
            <section className="section">
                <div className="row">


                    <div className="col-lg-10">

                        <div className="card">
                            <div className="card-body">

                       

                                <CssBaseline />
                                <Container maxWidth="md" sx={{ mt: 4 }}>
                                    {/*<Typography variant="h6" align="center" gutterBottom>*/}
                                    {/*  Car Admin Panel*/}
                                    {/*</Typography>*/}

                                    {/* Tabs */}
                                    <Box sx={{ width: '100%' }}>
                                        <AppBar position="static" color="transparent">
                                            <Tabs
                                                value={tabIndex}
                                                onChange={handleTabChange}
                                                indicatorColor="primary"
                                                textColor="primary"
                                                variant="fullWidth"
                                                aria-label="admin tabs"
                                            >
                                                <Tab label="Brands" id="admin-tab-0" aria-controls="admin-tabpanel-0" />
                                                <Tab label="Models" id="admin-tab-1" aria-controls="admin-tabpanel-1" />
                                                <Tab label="Body Type" id="admin-tab-2" aria-controls="admin-tabpanel-2" />
                                                <Tab label="Engine Class" id="admin-tab-3" aria-controls="admin-tabpanel-3" />
                                            </Tabs>
                                        </AppBar>

                                        {/* Tab Panels */}
                                        <TabPanel value={tabIndex} index={0}>
                                            {/* Brands Management */}
                                            <BrandForm brands={carbrands} addBrand={addBrand} />
                                            <Box mb={4} /> 

                                            <BrandTable

                                                deleteBrand={deleteBrand}
                                                
                                            />
                                        </TabPanel>
                                        <TabPanel value={tabIndex} index={1}>
                                            {/* Models Management */}
                                            <ModelFilter
                                                brands={carbrands}
                                                selectedBrandId={selectedBrandFilter}
                                                setSelectedBrandId={setSelectedBrandFilter}
                                            />
                                            <ModelForm brands={carbrands} models={carmodels} addModel={addModel} />
                                            <Box mb={4} />
                                            <ModelTable
                                                brands={carbrands}
                                                models={carmodels}
                                                deleteModel={deleteModel}
                                               
                                                filterBrandId={selectedBrandFilter}
                                            />
                                        </TabPanel>
                                        <TabPanel value={tabIndex} index={2}>
                                            {/* Brands Management */}
                                            <BodyForm body={bodytype} />
                                            <Box mb={4} /> 
                                            <BodyTable
                                                body={bodytype}
                                                deleteBody={deleteBody}
                                               
                                            />
                                        </TabPanel>
                                        <TabPanel value={tabIndex} index={3}>
                                            {/* Brands Management */}
                                            <EngineForm engine={engineclass} />
                                            <Box mb={4} /> 
                                            <EngineTable
                                                engine={engineclass}
                                                deleteEngine={deleteEngine}
                                                
                                            />
                                        </TabPanel>
                                    </Box>

                                    {/* Edit Dialog */}
                                    {/*<EditDialog*/}
                                    {/*    open={editOpen}*/}
                                    {/*    handleClose={() => setEditOpen(false)}*/}
                                    {/*    type={editType}*/}
                                    {/*    currentData={currentEditData}*/}
                                    {/*    brands={carbrands}*/}
                                    {/*    handleSave={handleSaveEdit}*/}
                                    {/*/>*/}


                                </Container>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );


};

export default CarMaster;

